import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer text-center">
        <div className="container">
          <small className="copyright">Copyright @ <a href="https://www.alexmaroz.com/" target="_blank" rel="noopener noreferrer">Alex Maroz</a></small>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ../components/Footer/index.jsx